import { render, staticRenderFns } from "./VeHrChangeModal.vue?vue&type=template&id=34b76ea8"
import script from "./VeHrChangeModal.vue?vue&type=script&lang=js"
export * from "./VeHrChangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports